import React from 'react';

import useTranslate from '../../../common/hooks/useTranslate';
import { useSelector } from 'react-redux';

import IdentityManager from '../../../common/services/identity/IdentityManagerFactory';

import { RootState } from '../../../redux/store';

import Icon from '../../ui/icon/icon';
import Logo from '../../ui/logo/logo';

import './errorPage.scss';

const ErrorPage: React.FC = () => {
  const { t } = useTranslate();

  const identity = IdentityManager.getManager();

  const user: string | null | undefined = useSelector((state: RootState) => state.user.name);

  let url = location.hostname === 'localhost' ? location.hostname + ':' + location.port : location.hostname;
  let redirect = 'https://' + url;

  return (
    <div className='no-match-content'>
      <div className='no-match-logo'>
        <Icon name='fas fa-exclamation-circle' className='no-match-error-icon' />
        <Logo logoSource='/branding/logo.png' />
      </div>
      <div className='no-match-text-large'>
        <span className='no-match-event-info'> {t('ERROR.TEXT1')}</span>
        <span> {t('ERROR.TEXT2')}</span>
      </div>
      <div className='no-match-text-info'>
        <p>{t('ERROR.INFO_TEXT1')}</p>
        <p>{t('ERROR.INFO_TEXT2')}</p>
        <a className='link-text' href='mailto:support@sanne.com'>
          {t('ERROR.INFO_TEXT_MAIL')}
        </a>
      </div>
      <div className='no-match-text-small'>
        <span>
          {t('ERROR.SIGNED_PERSON')} {user}
        </span>
      </div>
      <div className='no-match-buttons'>
        <a className='no-match-redirect-btn' href={redirect}>
          {t('ERROR.BACK_BUTTON')}
        </a>
        <div className='no-match-logout pointer' onClick={() => identity.signOut()}>
          {t('ERROR.LOGOUT')}
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
